import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import React, { useEffect } from 'react';
import 'react-image-crop/dist/ReactCrop.css';
import { ToastContainer } from 'react-toastify';
import './App.scss';
import theme from './assets/themes/theme';
import { AuthProvider } from './context/AuthContext';
import PageRouters from './routes/PageRouters';
import { KeycloakProvider } from './services/keycloak';
import { useTranslation } from 'react-i18next';
import { useSettings } from './context/SettingsContext';
import { vi, enGB } from 'date-fns/locale';
import { NotificationProvider } from './context/NotificationContext';
import MaintenancePage from './pages/ControlPanel/UserManagement/MaintenancePage';
import { useMaintenance } from './context/MaintenanceContext';
import VisitorRegistration from './pages/ControlPanel/VisitorManagement/VisitorRegistration';
import VisitorInvitation from './pages/ControlPanel/VisitorManagement/VisitorInvitation';
import ActiveAccount from './pages/Account/ActiveAccount';

const App = () => {
   const { settings } = useSettings();
   const { i18n } = useTranslation();
   const language = i18n.language;
   const { isMaintenance, setMaintenance } = useMaintenance();

   useEffect(() => {
      const onMaintenance = () => setMaintenance(true);
      const onRecover = () => setMaintenance(false);

      window.addEventListener("MAINTENANCE_MODE", onMaintenance);
      window.addEventListener("MAINTENANCE_RECOVER", onRecover);

      return () => {
         window.removeEventListener("MAINTENANCE_MODE", onMaintenance);
         window.removeEventListener("MAINTENANCE_RECOVER", onRecover);
      };
   }, [setMaintenance]);

   const isVisitorRegistration =
      window.location.pathname.includes("/visitor-registration");

   const isVisitorInvitation =
      window.location.pathname.includes("/visitor-invitation");

   // Ngoài KeycloakProvider để OIDC không chiếm query code/state sau SSO kích hoạt
   const isAccountActive =
      window.location.pathname.includes("/account/active");

   const locale = language === 'vi' ? vi : enGB;

   return (
      <LocalizationProvider
         dateAdapter={AdapterDateFns}
         adapterLocale={locale}
      >
         {isVisitorRegistration ? (
            <>
               <ThemeProvider theme={theme}>
                  <CssBaseline />
                  <VisitorRegistration />

                  <ToastContainer
                     position="bottom-right"
                     pauseOnHover={false}
                     autoClose={5000}
                  />
               </ThemeProvider>
            </>
         ) : isVisitorInvitation ? (
            <>
               <ThemeProvider theme={theme}>
                  <CssBaseline />
                  <VisitorInvitation />

                  <ToastContainer
                     position="bottom-right"
                     pauseOnHover={false}
                     autoClose={5000}
                  />
               </ThemeProvider>
            </>
         ) : isAccountActive ? (
            <>
               <ThemeProvider theme={theme}>
                  <CssBaseline />
                  <ActiveAccount />

                  <ToastContainer
                     position="bottom-right"
                     pauseOnHover={false}
                     autoClose={5000}
                  />
               </ThemeProvider>
            </>
         ) : isMaintenance ? (
            <ThemeProvider theme={theme}>
               <CssBaseline />
               <MaintenancePage />
            </ThemeProvider>
         ) : (
            <>
               <KeycloakProvider>
                  <ThemeProvider theme={theme}>
                     <CssBaseline />
                     <AuthProvider>
                        <NotificationProvider>
                           <PageRouters />
                        </NotificationProvider>
                     </AuthProvider>
                  </ThemeProvider>
               </KeycloakProvider>

               <ToastContainer
                  position="bottom-right"
                  pauseOnHover={false}
                  autoClose={5000}
               />
            </>
         )}
      </LocalizationProvider>
   );
};

export default App;